import { IColorTagsSearchScrollSetAction } from './types';
import { AT_COLOR_TAGS_SEARCH_SCROLL } from './constants';

export const colorTagsSearchScrollSet = (
): IColorTagsSearchScrollSetAction => {
    return {
        type: AT_COLOR_TAGS_SEARCH_SCROLL,
    }
};
